import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@one-thd/sui-atomic-components';
import { Add, Heart } from '@one-thd/sui-icons';
import { useTheme } from '@thd-olt-component-react/theme-provider';

const ADD_TO_LIST_THEME = {
  displayName: 'AddToList',
  defaultThemeProps: { showPlusSign: false },
};

export const AddToListIconButton = (props) => {
  const { onClick } = props;
  const theme = useTheme(ADD_TO_LIST_THEME, props);
  const { showPlusSign } = theme.props;

  return (
    <IconButton
      aria-label="Add To List"
      size="large"
      icon={showPlusSign ? Add : Heart}
      onClick={onClick}
    />
  );
};

AddToListIconButton.displayName = 'AddToListIconButton';

AddToListIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
